import type { CSSProperties } from "react";
import { REPORT_FONT_FAMILY } from "../../utils/reportPageLayout";

export type RowVariant = "row1" | "row";
export type RowAlign = "left" | "right";

export const reportTitleBarStyle: CSSProperties = {
  backgroundColor: "#E5E5E5",
  border: "1px solid #000000",
  textAlign: "center",
};

export const reportTitleTextStyle: CSSProperties = {
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: "14pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};

export const headerPracticeNameStyle: CSSProperties = {
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: "14pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};

export const headerContactLineStyle: CSSProperties = {
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: "10pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};

const patientRow1Style: CSSProperties = {
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: "12pt",
  fontWeight: 700,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};

export const patientRowStyle: CSSProperties = {
  fontFamily: REPORT_FONT_FAMILY,
  fontSize: "10pt",
  fontWeight: 400,
  lineHeight: 1.15,
  letterSpacing: 0,
  color: "#000000",
  margin: 0,
};

export const continuationHeaderStyle: CSSProperties = {
  ...patientRow1Style,
};

export function rowTextStyle(variant: RowVariant): CSSProperties {
  return variant === "row1" ? patientRow1Style : patientRowStyle;
}
